<div class="main-container">
  <div class="card-container">
    <mat-card class="card" (click)="navigateToPermission()">
      <mat-card-header>
        <mat-card-title>
          <h4>User Permissions</h4>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>Give or remove permissions for users in given company.</p>
      </mat-card-content>
    </mat-card>
    <mat-card
      class="card"
      (click)="navigateToBrandAccount()"
      *ngIf="showBrandAcct === true"
    >
      <mat-card-header>
        <mat-card-title>
          <h4>Brand Account Definitions</h4>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>Update or create definitions for brands by account.</p>
      </mat-card-content>
    </mat-card>
    <mat-card class="card" (click)="navigateToMrc()" *ngIf="showMrc === true">
      <mat-card-header>
        <mat-card-title>
          <h4>MRC</h4>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>
          Edit Marketing Resource Center "Groupname" and "Reports-To" for
          individual users.
        </p>
      </mat-card-content>
    </mat-card>
    <mat-card
      class="card"
      (click)="navigateToRecommitProcess()"
      *ngIf="showRecommit === true"
    >
      <mat-card-header>
        <mat-card-title>
          <h4>Recommit Process</h4>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>
          Upload an Excel spreadsheet of orders that received a recommit date
          and send emails to those users.
        </p>
      </mat-card-content>
    </mat-card>
    <mat-card
      class="card"
      (click)="navigateToEdit()"
      *ngIf="showBrandAcct === true"
    >
      <mat-card-header>
        <mat-card-title>
          <h4>Edit Program Content</h4>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>
          Edit program content that will be displayed in the Authorized Seller
          Application.
        </p>
      </mat-card-content>
    </mat-card>
    <mat-card class="card" (click)="navigateToRewards()">
      <mat-card-header>
        <mat-card-title>
          <h4>Rewards Program Permissions</h4>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>
          Give or remove Rewards Program permissions for users in a given
          company and branch.
        </p>
      </mat-card-content>
    </mat-card>
  </div>
</div>
